import React, { Component } from 'react';

import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { TREND_DETAIL_AGE_GENDER_SET } from '../../../../config/TrendDetailAgeGenderSet';

class LineForTrend extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clickedData: null,
      showModal: false
    }
  }

  componentDidMount() {
    const data = this.props.data;
    const timeunit = this.props.timeunit;
    const datatype = this.props.datatype;
    const excelExportFunc = this.props.excelExportFunc;
    const reportType = this.props.reportType;
    const reportName = this.props.reportName;
    let chart = null;

    switch (reportType) {
      case "volume": {
        this.createVolumeLineForTrend(chart, reportName, data, timeunit, datatype, excelExportFunc);
        break;
      }
      case "detail": {
        this.createDetailLineForTrend(chart, reportName, data, timeunit, datatype, excelExportFunc);
        break;
      }
      default:
        break;
    }
  }

  componentWillUnmount() {
    if (this.chart) {
      this.chart.dispose()
    };
  }

  componentDidUpdate(prevProps) {
    if ((this.props.data != null) && (prevProps.data !== this.props.data)) {
      if (this.chart) {
        this.chart.dispose();
      }
      const data = this.props.data;
      const timeunit = this.props.timeunit;
      const datatype = this.props.datatype;
      const excelExportFunc = this.props.excelExportFunc;
      const reportType = this.props.reportType;
      const reportName = this.props.reportName;

      let chart = null;

      switch (reportType) {
        case "volume": {
          this.createVolumeLineForTrend(chart, reportName, data, timeunit, datatype, excelExportFunc);
          break;
        }
        case "detail": {
          this.createDetailLineForTrend(chart, reportName, data, timeunit, datatype, excelExportFunc);
          break;
        }
        default:
          break;
      }
    }
  }

  createVolumeLineForTrend = (chart, reportName, dataSet, timeunit, datatype, excelExportFunc) => {
    chart = am4core.create(this.lineChart, am4charts.XYChart);
    am4core.useTheme(am4themes_animated);

    chart.data = dataSet.data;
    let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

    valueAxis.min = 0;

    dateAxis.renderer.minGridDistance = 20;
    dateAxis.renderer.labels.template.rotation = 90;
    dateAxis.renderer.labels.template.horizontalCenter = "left";
    dateAxis.renderer.labels.template.verticalCenter = "middle";


    switch (timeunit) {
      case "daily": {
        dateAxis.dateFormats.setKey("day", "yyyy-MM-dd");
        dateAxis.periodChangeDateFormats.setKey("day", "yyyy-MM-dd");
        dateAxis.baseInterval = { timeUnit: "day", count: 1 };
        break;
      }
      case "weekly": {
        dateAxis.dateFormats.setKey("day", "yyyy-MM-dd");
        dateAxis.periodChangeDateFormats.setKey("day", "yyyy-MM-dd");
        dateAxis.baseInterval = { timeUnit: "day", count: 1 };
        dateAxis.skipEmptyPeriods = true;
        break;
      }
      case "monthly": {
        dateAxis.dateFormats.setKey("month", "yyyy-MM");
        dateAxis.periodChangeDateFormats.setKey("month", "yyyy-MM");

        dateAxis.baseInterval = { timeUnit: "month", count: 1 };
        break;
      }
      default:
        break;
    }

    valueAxis.renderer.grid.template.disabled = true;
    valueAxis.renderer.baseGrid.disabled = true;
    dateAxis.renderer.grid.template.disabled = true;

    if (datatype == 'numeric') {
      valueAxis.renderer.labels.template.adapter.add("text", function (text, target) {
        if (typeof (text) == "string") {
          let dotIndex = text.indexOf('.');
          if (dotIndex == -1) {
            return text;
          }
          else if (dotIndex != -1 && text[dotIndex + 1] == '0') {
            return text.slice(0, dotIndex);
          }
        }
      });
    }
    else if (datatype == 'percentage') {
      valueAxis.calculateTotals = true;
      valueAxis.min = 0;
      valueAxis.max = 100;
    }

    dataSet.query.forEach((item, index) => {
      // chart.series.push(this.createVolumeSeries(`${item} (pc)`, `pc${index}`, timeunit, datatype))
      // chart.series.push(this.createVolumeSeries(`${item} (mo)`, `mo${index}`, timeunit, datatype))
      chart.series.push(this.createVolumeSeries(`${item} (all)`, `all${index}`, timeunit, datatype))
    })


    chart.legend = new am4charts.Legend();

    chart.cursor = new am4charts.XYCursor();
    dateAxis.cursorTooltipEnabled = false;
    valueAxis.cursorTooltipEnabled = false;
    chart.cursor.lineX.disabled = true;
    chart.cursor.lineY.disabled = true;
    chart.cursor.behavior = "none";

    chart.exporting.menu = new am4core.ExportMenu();
    chart.exporting.menu.container = document.getElementById("export-container");

    let today = new Date();
    chart.exporting.filePrefix = `${reportName}_${today.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3')}`;
    chart.exporting.useWebFonts = false;
    chart.exporting.menu.items = [
      {
        "label": "...",
        "menu": [
          {
            "type": "png",
            "label": "PNG"
          },
          {
            "type": "jpg",
            "label": "JPG"
          },
          {
            "type": "custom",
            "label": "Excel",
            "options": {
              callback: excelExportFunc
            }
          }
        ]
      }
    ]
    this.chart = chart;
  }

  //value => channel
  createVolumeSeries = (name, value, timeunit, datatype) => {
    let retSeries = new am4charts.LineSeries();
    retSeries.dataFields.valueY = value;
    retSeries.dataFields.dateX = "date";
    retSeries.name = name;
    retSeries.strokeWidth = 5;

    // retSeries.stroke = am4core.color(CHANNEL_COLOR_SET[value]);
    // retSeries.minBulletDistance = 1000;
    retSeries.minBulletDistance = 10;


    let retBullet = retSeries.bullets.push(new am4charts.CircleBullet());
    retSeries.stroke = retBullet.circle.fill;
    // retBullet.circle.fill = am4core.color(CHANNEL_COLOR_SET[value]);

    retBullet.circle.radius = 4;
    // retBullet.events.on("hit", (ev) => {
    //   this.createBuzzlistWindow(ev.target.dataItem.dataContext);
    // })
    retSeries.tooltip.pointerOrientation = "up";

    if (datatype == 'numeric') {
      switch (timeunit) {
        case "daily": {
          retSeries.tooltipText = `${name} ({dateX}): [bold]{valueY}[/]`
          break;
        }
        case "weekly": {
          retSeries.tooltipText = `${name} ({dateX}~{end_date}): [bold]{valueY}[/]`
          break;
        }
        case "monthly": {
          retSeries.tooltipText = `${name} ({dateX}~{end_date}): [bold]{valueY}[/]`
          break;
        }
        default:
          break;
      }
    }
    else if (datatype == 'percentage') {
      switch (timeunit) {
        case "daily": {
          retSeries.tooltipText = `${name} ({dateX}): [bold]{valueY.totalPercent.formatNumber('#.#')}[/]`
          break;
        }
        case "weekly": {
          retSeries.tooltipText = `${name} ({dateX}~{end_date}): [bold]{valueY.totalPercent.formatNumber('#.#')}[/]`
          break;
        }
        case "monthly": {
          retSeries.tooltipText = `${name} ({dateX}~{end_date}): [bold]{valueY.totalPercent.formatNumber('#.#')}[/]`
          break;
        }
        default:
          break;
      }
    }
    retSeries.tooltip.getFillFromObject = true;
    retSeries.tooltip.background.fill = retBullet.circle.fill;
    // retSeries.tooltip.label.fill = am4core.color("#000000");

    if (datatype == 'numeric') {

    }
    else if (datatype == 'percentage') {
      retSeries.dataFields.valueYShow = 'totalPercent';
    }

    return retSeries;
  }

  createDetailLineForTrend = (chart, reportName, dataSet, timeunit, datatype, excelExportFunc) => {
    chart = am4core.create(this.lineChart, am4charts.XYChart);
    am4core.useTheme(am4themes_animated);

    chart.data = dataSet.data;
    let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

    valueAxis.min = 0;

    dateAxis.renderer.minGridDistance = 20;
    dateAxis.renderer.labels.template.rotation = 90;
    dateAxis.renderer.labels.template.horizontalCenter = "left";
    dateAxis.renderer.labels.template.verticalCenter = "middle";


    switch (timeunit) {
      case "daily": {
        dateAxis.dateFormats.setKey("day", "yyyy-MM-dd");
        dateAxis.periodChangeDateFormats.setKey("day", "yyyy-MM-dd");
        dateAxis.baseInterval = { timeUnit: "day", count: 1 };
        break;
      }
      case "weekly": {
        dateAxis.dateFormats.setKey("day", "yyyy-MM-dd");
        dateAxis.periodChangeDateFormats.setKey("day", "yyyy-MM-dd");
        dateAxis.baseInterval = { timeUnit: "day", count: 1 };
        dateAxis.skipEmptyPeriods = true;
        break;
      }
      case "monthly": {
        dateAxis.dateFormats.setKey("month", "yyyy-MM");
        dateAxis.periodChangeDateFormats.setKey("month", "yyyy-MM");

        dateAxis.baseInterval = { timeUnit: "month", count: 1 };
        break;
      }
      default:
        break;
    }

    valueAxis.renderer.grid.template.disabled = true;
    valueAxis.renderer.baseGrid.disabled = true;
    dateAxis.renderer.grid.template.disabled = true;

    if (datatype == 'numeric') {
      valueAxis.renderer.labels.template.adapter.add("text", function (text, target) {
        if (typeof (text) == "string") {
          let dotIndex = text.indexOf('.');
          if (dotIndex == -1) {
            return text;
          }
          else if (dotIndex != -1 && text[dotIndex + 1] == '0') {
            return text.slice(0, dotIndex);
          }
        }
      });
    }
    else if (datatype == 'percentage') {
      valueAxis.calculateTotals = true;
      valueAxis.min = 0;
      valueAxis.max = 100;
    }

    dataSet.query.forEach((queryItem, queryIndex) => {
      // chart.series.push(this.createDetailSeries(`${item} (pc)`, `pc${index}`, timeunit, datatype))
      // chart.series.push(this.createDetailSeries(`${item} (mo)`, `mo${index}`, timeunit, datatype))
      // chart.series.push(this.createDetailSeries(`${item} (all)`, `all${index}`, timeunit, datatype))
      dataSet.genderage.forEach((gaItem, gaIndex) => {
        chart.series.push(this.createDetailSeries(`${queryItem} (${TREND_DETAIL_AGE_GENDER_SET[gaItem]})`, `all${queryIndex}-${gaItem}`, timeunit, datatype));
      })
    })


    chart.legend = new am4charts.Legend();

    chart.cursor = new am4charts.XYCursor();
    dateAxis.cursorTooltipEnabled = false;
    valueAxis.cursorTooltipEnabled = false;
    chart.cursor.lineX.disabled = true;
    chart.cursor.lineY.disabled = true;
    chart.cursor.behavior = "none";

    chart.exporting.menu = new am4core.ExportMenu();
    chart.exporting.menu.container = document.getElementById("export-container");

    let today = new Date();
    chart.exporting.filePrefix = `${reportName}_${today.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3')}`;
    chart.exporting.useWebFonts = false;
    chart.exporting.menu.items = [
      {
        "label": "...",
        "menu": [
          {
            "type": "png",
            "label": "PNG"
          },
          {
            "type": "jpg",
            "label": "JPG"
          },
          {
            "type": "custom",
            "label": "Excel",
            "options": {
              callback: excelExportFunc
            }
          }
        ]
      }
    ]
    this.chart = chart;
  }

  //value => channel
  createDetailSeries = (name, value, timeunit, datatype) => {
    let retSeries = new am4charts.LineSeries();
    retSeries.dataFields.valueY = value;
    retSeries.dataFields.dateX = "date";
    retSeries.name = name;
    retSeries.strokeWidth = 5;

    // retSeries.stroke = am4core.color(CHANNEL_COLOR_SET[value]);
    // retSeries.minBulletDistance = 1000;
    retSeries.minBulletDistance = 10;


    let retBullet = retSeries.bullets.push(new am4charts.CircleBullet());
    retSeries.stroke = retBullet.circle.fill;
    // retBullet.circle.fill = am4core.color(CHANNEL_COLOR_SET[value]);

    retBullet.circle.radius = 4;
    // retBullet.events.on("hit", (ev) => {
    //   this.createBuzzlistWindow(ev.target.dataItem.dataContext);
    // })
    retSeries.tooltip.pointerOrientation = "up";

    if (datatype == 'numeric') {
      switch (timeunit) {
        case "daily": {
          retSeries.tooltipText = `${name} ({dateX}): [bold]{valueY}[/]`
          break;
        }
        case "weekly": {
          retSeries.tooltipText = `${name} ({dateX}~{end_date}): [bold]{valueY}[/]`
          break;
        }
        case "monthly": {
          retSeries.tooltipText = `${name} ({dateX}~{end_date}): [bold]{valueY}[/]`
          break;
        }
        default:
          break;
      }
    }
    else if (datatype == 'percentage') {
      switch (timeunit) {
        case "daily": {
          retSeries.tooltipText = `${name} ({dateX}): [bold]{valueY.totalPercent.formatNumber('#.#')}[/]`
          break;
        }
        case "weekly": {
          retSeries.tooltipText = `${name} ({dateX}~{end_date}): [bold]{valueY.totalPercent.formatNumber('#.#')}[/]`
          break;
        }
        case "monthly": {
          retSeries.tooltipText = `${name} ({dateX}~{end_date}): [bold]{valueY.totalPercent.formatNumber('#.#')}[/]`
          break;
        }
        default:
          break;
      }
    }
    retSeries.tooltip.getFillFromObject = true;
    retSeries.tooltip.background.fill = retBullet.circle.fill;
    // retSeries.tooltip.label.fill = am4core.color("#000000");

    if (datatype == 'numeric') {

    }
    else if (datatype == 'percentage') {
      retSeries.dataFields.valueYShow = 'totalPercent';
    }

    return retSeries;
  }

  render() {
    return (
      <div>
        <div id="export-container" style={{ position: "relative", minHeight: "30px" }} />
        <div id="line" ref={ref => (this.lineChart = ref)} style={{ width: this.props.width, height: this.props.height }}></div>
      </div>
    )
  }
}

export default LineForTrend;